/*
 * Created: 2019-07-04 09:27:02
 * Author : zc
 * Email : 591074801@qq.com
 * -----
 * Description: ship api
 */
import request from '@/utils/request';
/**顺丰寄件结算方式 */
export const shipSettlementStatus = [
  { key: 'DeliverFeeToBeCollected', value: '到付' },
  { key: 'DeliveryFeePrepaidNow', value: '寄付现结' },
  { key: 'DeliveryFeePrepaidMonthly', value: '寄付月结' }
  // { key: 'ThirdPartyPay', value: '第三方付' }
];

// 发货列表筛选状态
export const shipStatus = [
  { key: 'ToBeShip', value: '待发货' },
  { key: 'Shipped', value: '已发货' },
  { key: 'Cancel', value: '已取消' },
  { key: 'ToBeGivenOut', value: '待发放' },
  { key: 'AlreadyReceived', value: '已领取' },
  { key: 'Receiving', value: '待领取' }
];
/**物流状态 */
export const shipLogicStatus = [
  { key: 'ToBeShip', value: '待发货' },
  { key: 'Shipped', value: '已发货' },
  { key: 'Cancel', value: '已取消' },
  { key: 'OrderCancel', value: '订单取消' },
  { key: 'ToBeGivenOut', value: '待发放' },
  { key: 'AlreadyGivenOut', value: '已发放' },
  { key: 'GiveOut ', value: '发放' },
  { key: 'AlreadyReceived', value: '已领取' },
  { key: 'Receiving', value: '待领取' }
];

/**字体颜色 */
export const getShipStatusColor = function(status: string) {
  switch (status) {
    case 'ToBeShip':
      return 'color: #FF0000';
    case 'Shipped':
      return 'color: #00A854';
    case 'Cancel':
      return 'color: #999999';
  }
};

/**物流状态 */
export const shipCompany = [
  { key: '顺丰', value: 'shunfeng' },
  { key: '圆通', value: 'yuantong' },
  { key: '德邦', value: 'debangwuliu' },
  { key: '中通', value: 'zhongtong' },
  { key: '自提', value: 'SelfMention' }
];

/**物流状态名称 */
export const getShipStatusName = function(key: any) {
  let name = '';
  shipLogicStatus.map((v: any) => {
    if (v.key == key) {
      name = v.value;
    }
  });
  return name;
};

/**物流公司名称 */
export const getShipCompanyName = function(key: any) {
  let name = '';
  shipCompany.map((v: any) => {
    if (v.value == key) {
      name = v.key;
    }
  });
  return name;
};

/**发货列表 */
export const shipList = function(formData?: any) {
  return request.get('/api/Shipment/ShipList', {
    ...formData
  });
};

/**发货 */
export const ship = function(formData: any) {
  return request.post(`/api/Shipment/ship`, { ...formData });
};
// export const ship = function (id: string, formData: any) {
//     return request.post(`/api/Shipment/${id}/ship`, { ...formData })
// }

/**修改发货信息发货 */
export const putShip = function(formData: any) {
  return request.put(`/api/Shipment/Logistics`, { ...formData });
};
// export const putShip = function (id: string, formData: any) {
//     return request.put(`/api/Shipment/${id}/ship`, { ...formData })
// }

/**检测是否可以合并发货 */
export const checkMergeShip = function(formData: any) {
  return request.post('/api/Shipment/checkMergeShip', { ...formData });
};

/**合并发货 */
export const mergeShip = function(formData: any) {
  return request.post('/api/Shipment/ship', { ...formData });
  // return request.post('/api/Shipment/mergeShip', { ...formData })
};

/**取消发货 */
export const cancelShip = function(id: string) {
  return request.post(`/api/Shipment/${id}/cancelShip`, {});
};

/**批量取消发货 */
export const batchCancelShip = function(formData: any) {
  return request.post('/api/Shipment/batchCancelShip', { ...formData });
};

/**取消出库 */
export const cancel = function(id: string) {
  return request.post(`/api/Shipment/${id}/cancel`, {});
};

/**批量取消出库 */
export const batchCancel = function(formData: any) {
  return request.post('/api/Shipment/batchCancel', { ...formData });
};

/**查看物流 */
export const logistics = function(param: any) {
  // return request.get(`/api/Shipment/${id}/Logistics`, {})
  return request.get(`/api/Shipment/Logistics/${param.id}`, param);
};

/**顺丰寄件 */
export const shipBySf = function(formData: any) {
  return request.post('/api/Shipment/ShipBySf', { ...formData });
  // return request.post(`/api/Shipment/${id}/ShipBySf`, {})
};
// export const shipBySf = function (id: string) {
//     return request.post(`/api/Shipment/${id}/ShipBySf`, {})
// }

/**顺丰批量寄件 */
export const shipMergeBySf = function(formData: any) {
  return request.post('/api/Shipment/ShipBySf', { ...formData });
  // return request.post('/api/Shipment/mergeShipBySf', { ...formData })
};

/**删除发货信息 */
export const deleteShip = function(id: any) {
  return request.del(`/api/Shipment/Logistics/${id}`, {});
};

/**获取出库单打印数据 */
export const getOrderPrintData = function(id: any) {
  return request.get(`/api/Shipment/${id}/print`, {});
};

// 发货列表导出
export const exportShipment = (form: any) => {
  return request.download(`/api/Shipment/Export`, { ...form });
};

// 获取中通打印结果
export const getZhongTongPrintResult = (formData: any) => {
  return request.post(`/api/Shipment/GetZhongTongPrint`, { ...formData });
};
